import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { getApplicationDomain } from '../constants/apiEnvironments';
import { getHubSpotForStartupsRedirect } from './getHSFXFallbackRedirectUrl';
import { hubSpotEngageAIRedirect } from './productLinks';
const getFlowToFallbackUrl = new Map([[Flow.Academy, (portalId, hublet) => `${getApplicationDomain(hublet)}/academy/${portalId}`], [Flow.HubspotForStartups, (portalId, hublet) => getHubSpotForStartupsRedirect({
  portalId,
  hublet
})], [Flow.EngageAI, (portalId, hublet, isNewUser) => hubSpotEngageAIRedirect({
  portalId,
  hublet,
  isNewUser
})]]);
export const getFallbackOnboardingUrl = (portalId, hublet, isNewUser) => {
  const flowKey = getFlowKey();
  const fallback = getFlowToFallbackUrl.get(flowKey);
  if (fallback) {
    return fallback(portalId, hublet, isNewUser);
  }
  return `${getApplicationDomain(hublet)}/getting-started/${portalId}`;
};